import React from 'react'
import { Text, TouchableOpacity } from 'react-native'
import PropTypes from 'prop-types'
import { colors } from '../../styles'
import dialogStyles from '../../styles/dialog'

export default function DialogButton(props) {
  const {
    buttonText,
    testID,
    onPress,
    maxFontSizeMultiplier,
    disabled,
    marginBottom,
    accessibilityLabel,
  } = props
  return (
    <TouchableOpacity
      testID={testID}
      onPress={onPress}
      style={{ justifyContent: 'center', marginBottom }}
      disabled={disabled}
      accessibilityLabel={accessibilityLabel || buttonText}
    >
      <Text
        allowFontScaling
        maxFontSizeMultiplier={maxFontSizeMultiplier}
        style={[dialogStyles.dialogButtonFont, {
          color: disabled ? colors.darkGray : colors.actionBlue,
          textTransform: 'uppercase',
          fontWeight: '500',
          margin: 8,
        }]}
      >
        {buttonText}
      </Text>
    </TouchableOpacity>
  )
}

DialogButton.propTypes = {
  buttonText: PropTypes.string.isRequired,
  testID: PropTypes.string.isRequired,
  onPress: PropTypes.func.isRequired,
  maxFontSizeMultiplier: PropTypes.number,
  disabled: PropTypes.bool,
  marginBottom: PropTypes.number,
  accessibilityLabel: PropTypes.string,
}

DialogButton.defaultProps = {
  maxFontSizeMultiplier: 1.4,
  disabled: false,
  marginBottom: 0,
  accessibilityLabel: null,
}
